module.exports = __webpack_public_path__ + "b2dffaf70265ff428ca077a64a92266a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Rist/content/tourWorks/room3/audio5/RIST-15-not-the-girl.jpg
// module id = 897
// module chunks = 0